module.exports = __webpack_public_path__ + "img/0100.aa25ecae.jpg";